import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/lib/auth';
import { PATIENT_PORTAL_PATH } from '@/lib/staffAccess';
import { AuthShell } from './AuthShell';
import { Button, ButtonLink } from '@/components/ui/Button';

/**
 * Full-page stand-in for the staff app shell when a patient-only account
 * signs in at a clinic-staff URL. No sidebar, no staff data queries.
 */
export function PatientStaffBlocked() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { signOut } = useAuth();
  const [signingOut, setSigningOut] = useState(false);

  const handleSignOut = async () => {
    if (signingOut) return;
    setSigningOut(true);
    try {
      await signOut();
    } finally {
      navigate('/sign-in', { replace: true });
    }
  };

  return (
    <AuthShell
      title={t('auth.patient_staff_block.title')}
      subtitle={t('auth.patient_staff_block.body')}
    >
      <div className="space-y-3">
        <ButtonLink to={PATIENT_PORTAL_PATH} size="full">
          {t('auth.patient_staff_block.go_to_portal')}
        </ButtonLink>
        <Button
          variant="secondary"
          size="full"
          onClick={() => {
            void handleSignOut();
          }}
          disabled={signingOut}
        >
          {t('auth.patient_staff_block.sign_out')}
        </Button>
      </div>
    </AuthShell>
  );
}
